// src/hooks/hotelRoomCategories/useCreateHotelRoomCategory.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createHotelRoomCategory } from "../../api/apiHotelRoomCategories";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateHotelRoomCategory = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createHotelRoomCategories, isPending } = useMutation({
        mutationFn: createHotelRoomCategory,
        onSuccess: (res) => {
            const message = res?.message || "Hotel room category created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRoomCategories"] });
            navigate("/hotel-room-categories");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create hotel room category");
        },
    });

    return { createHotelRoomCategories, isPending };
};

export default useCreateHotelRoomCategory;
